export enum ConstructionStatusEnum {
  proposed = 'Proposed',
  under_construction = 'Under Construction',
  existing = 'Existing',
  demolished = 'Demolished',
}

export const constructionStatusOptions: ConstructionStatusEnum[] = Object.values(ConstructionStatusEnum) as ConstructionStatusEnum[];
